import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {openInBrowser} from '../../../../srcCommon/browser/openInBrowser';
import {ContactSourcesEnum} from '../../../models/api/contactModel';

/*
 * Props.
 */

interface ContactCardExternalLinkButtonProps {
  handle: string;
  source: ContactSourcesEnum;
}

/*
 * Component.
 */

export const ContactCardExternalLinkButton: FC<ContactCardExternalLinkButtonProps> = (props) => {
  const theme = useUserTheme();
  const {handle, source} = props;

  if (source !== ContactSourcesEnum.TWITTER && source !== ContactSourcesEnum.TWITTER_DM) {
    return null;
  }

  return (
    <IconButton
      iconName="externalLinkSmall"
      color={theme.greys.shade70}
      label={renderHandleLabel(source)}
      onClick={onClickHandler(handle, source)}
    />
  );
};

/*
 * Helpers.
 */

function renderHandleLabel(source: ContactSourcesEnum) {
  switch (source) {
    case ContactSourcesEnum.TWITTER:
    case ContactSourcesEnum.TWITTER_DM:
      return <Trans id="contact-card-item-url-view-twitter-profile">View Twitter profile</Trans>;
    default:
      return null;
  }
}

function onClickHandler(handle: string, source: ContactSourcesEnum) {
  switch (source) {
    case ContactSourcesEnum.TWITTER:
    case ContactSourcesEnum.TWITTER_DM:
      return () => openInBrowser(`https://twitter.com/${handle}`);
    default:
      return undefined;
  }
}
